(($) => {
  const setEqualHeight = (elements) => {
    const ele = $(elements);
    const heights = ele.map((index, element) => $(element).css('height', 'auto').height()).get();
    const maxHeight = Math.max(...heights);
    ele.height(maxHeight);
  };

  const equalHeightCards = () => {
    const winWidth = document.documentElement.clientWidth;
    const sectionBenefits = $('.js-equal-height-cards');

    sectionBenefits.each((index, element) => {
      const $this = $(element);
      const benefitsCard = $this.find('.js-equal-height-card-wrapper > .ct-div-block');

      if (winWidth > 991) {
        $.each(benefitsCard, (index) => {
          if (index % 3 === 0) {
            setEqualHeight(benefitsCard.slice(index, index + 3).find('.ct-headline'));
          }
        });
      } else {
        benefitsCard.find('.ct-headline').removeAttr('style');
      }
    });
  };

  $(window).on('load resize', () => {
    equalHeightCards();
  });
})(jQuery);